import { createGlobalStyle } from "styled-components"

// Reset plus the page ground. Everything else is a component.
export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  body {
    margin: 0;
    background: ${({ theme }) => theme.color.bg};
    color: ${({ theme }) => theme.color.ink};
    font-family: ${({ theme }) => theme.font.body};
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  a { color: ${({ theme }) => theme.color.accent}; text-decoration: none; }
  a:hover { text-decoration: underline; }

  h1, h2, h3 { font-family: ${({ theme }) => theme.font.display}; font-weight: 600; margin: 0; }
  h1 { font-size: 34px; letter-spacing: -0.015em; }

  code, pre { font-family: ${({ theme }) => theme.font.mono}; }
`

export default GlobalStyle
